import { QueryClient } from "react-query";

export const cacheClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});
